import { setLoading } from "../generalActions/mainActions";
import { addItem, changeListItem, removeItem, setItems, setTableParams } from "../generalActions/listActions";
import { setForm, setItem } from "../generalActions/formActions";
import {notificationsService} from "../../../jwt/_services/comunication/notificationsService";

export const search = (pageIndex, pageSize, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    notificationsService.search(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return

            dispatch(setItems(result.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total))
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = data => ( dispatch ) => {
    dispatch(setLoading(true))

    notificationsService.saveItem(data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( addItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    notificationsService.updateItem(id, data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( changeListItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (id, fbDdataBase) => ( dispatch ) => {
    dispatch(setLoading(true))

    notificationsService.deleteItem(id, fbDdataBase)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) ) // TODO: tenemos que ver cual es el flujo de delete
        })
        .finally(() => dispatch(setLoading(false)))
}

export const sendAlert = (data) => ( dispatch ) => {
    dispatch(setLoading(true))

    notificationsService.sendAlert(data)
        .then( result => {})
        .finally(() => dispatch(setLoading(false)))
}